export default String.raw`
<g id="Tekst SEO/desktop" class="textElementFont">
    <g id="Tekst SEO">
        <rect width="1440" height="360" class="textElementBg"/>
        <g id="4. Text Button" class="iconColors">
            <text id="Text" xml:space="preserve" style="white-space: pre" font-size="14" font-weight="600" letter-spacing="0px"><tspan x="130.326" y="321.091">TRANSLATION_Prv_RollOutDescription</tspan></text>
            <g id="Arrows/chevron down" transform="translate(220, 310)">
                <use href="#chevron-down" width="12" height="12"></use>
            </g>
        </g>
        <g id="Zawartosc" clip-path="url(#clip0_2076_723935)">
            <rect width="1180" height="256" transform="translate(130 32)" class="textElementBg"/>
            <g id="kolumna 1 ">
                <text xml:space="preserve" style="white-space: pre" font-size="18" font-weight="600" letter-spacing="0px"><tspan x="130" y="50.5455">TRANSLATION_Prv_CategoryDesc_Title</tspan></text>
                <text xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="130" y="87.0909">TRANSLATION_Prv_CategoryDesc_ParaOne_LineOne </tspan><tspan x="130" y="107.091">TRANSLATION_Prv_CategoryDesc_ParaOne_LineTwo</tspan><tspan x="130" y="127.091">&#x2028;</tspan><tspan x="130" y="147.091">TRANSLATION_Prv_CategoryDesc_ParaTwo_LineOne </tspan><tspan x="130" y="167.091">TRANSLATION_Prv_CategoryDesc_ParaTwo_LineTwo</tspan></text>
                <g id="Frame 3141">
                    <text xml:space="preserve" style="white-space: pre" font-size="16" font-weight="600" letter-spacing="0px"><tspan x="130" y="203.818">TRANSLATION_Prv_CategoryDesc_Subtitle</tspan></text>
                    <text xml:space="preserve" style="white-space: pre" font-size="14" letter-spacing="0px"><tspan x="130" y="239.091">TRANSLATION_Prv_CategoryDesc_ParaThree_LineOne </tspan><tspan x="130" y="259.091">TRANSLATION_Prv_CategoryDesc_ParaThree_LineTwo </tspan><tspan x="130" y="279.091">TRANSLATION_Prv_CategoryDesc_ParaThree_LineThree</tspan>
                </g>
            </g>
            <g id="shade">
                <rect width="216" height="1441" transform="matrix(0 1 -1 0 1441 144)" fill="url(#paint0_linear_2076_723935)"/>
            </g>
        </g>
    </g>
    <defs>
        <linearGradient id="paint0_linear_2076_723935" x1="216" y1="720.5" x2="-4.43419e-06" y2="720.5" gradientUnits="userSpaceOnUse">
            <stop class="textElementBg--stop"/>
            <stop offset="1" class="textElementBg--stop" stop-opacity="0"/>
        </linearGradient>
        <clipPath id="clip0_2076_723935">
            <rect width="1180" height="256" transform="translate(130 32)"/>
        </clipPath>
    </defs>
</g>
`;